import { render, staticRenderFns } from "./AgentCommonProduct.vue?vue&type=template&id=97bfb390&scoped=true&"
import script from "./AgentCommonProduct.vue?vue&type=script&lang=js&"
export * from "./AgentCommonProduct.vue?vue&type=script&lang=js&"
import style0 from "./AgentCommonProduct.vue?vue&type=style&index=0&id=97bfb390&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97bfb390",
  null
  
)

export default component.exports